
export class ContentMetaData {
    public __classname__: string = 'ContentMetaData';

    public Description : string | null = null;
	public DescriptionAuthor: string | null = null;
	public Keywords: string[] | null = null;
	public Slugline: string | null = null;
	public Format: string | null = null;
	public Columns: number | null = null;
	public Width: number | null = null;
	public Height: number | null = null;
	public Dpi: number | null = null;
	public LengthWords: number | null = null;
	public LengthChars: number | null = null;
	public LengthParas: number | null = null;
	public LengthLines: number | null = null;
	public PlainContent: string | null = null;
	public FileSize: number | null = null;
	public ColorSpace: string | null = null;
	public HighResFile: string | null = null;
	public Encoding: string | null = null;
	public Compression: string | null = null;
	public KeyFrameEveryFrames: number | null = null;
	public Channels: string | null = null;
	public AspectRatio: string | null = null;
	public Orientation: number | null = null;
	public Dimensions: string | null = null;

    constructor(params : ContentMetaDataNamedParameters) {
        this.Description = params.Description ?? null;
        this.DescriptionAuthor = params.DescriptionAuthor ?? null;
        this.Keywords = params.Keywords ?? null;
        this.Slugline = params.Slugline ?? null;
        this.Format = params.Format ?? null;
        this.Columns = params.Columns ?? null;
        this.Width = params.Width ?? null;
        this.Height = params.Height ?? null;
        this.Dpi = params.Dpi ?? null;
        this.LengthWords = params.LengthWords ?? null;
        this.LengthChars = params.LengthChars ?? null;
        this.LengthParas = params.LengthParas ?? null;
        this.LengthLines = params.LengthLines ?? null;
        this.PlainContent = params.PlainContent ?? null;
        this.FileSize = params.FileSize ?? null;
        this.ColorSpace = params.ColorSpace ?? null;
        this.HighResFile = params.HighResFile ?? null;
        this.Encoding = params.Encoding ?? null;
        this.Compression = params.Compression ?? null;
        this.KeyFrameEveryFrames = params.KeyFrameEveryFrames ?? null;
        this.Channels = params.Channels ?? null;
        this.AspectRatio = params.AspectRatio ?? null;
        this.Orientation = params.Orientation ?? null;
        this.Dimensions = params.Dimensions ?? null;
    }
}

export interface ContentMetaDataNamedParameters{
    Description? : string 
    DescriptionAuthor? : string 
    Keywords? : string[] 
    Slugline? : string 
    Format? : string 
    Columns? : number 
    Width? : number 
    Height? : number 
    Dpi? : number
    LengthWords? : number 
    LengthChars? : number 
    LengthParas? : number 
    LengthLines? : number 
    PlainContent? : string 
    FileSize? : number 
    ColorSpace? : string 
    HighResFile? : string 
    Encoding? : string 
    Compression? : string 
    KeyFrameEveryFrames? : number 
    Channels? : string 
    AspectRatio? : string 
    Orientation? : number 
    Dimensions? : string 
}